
import { ref, defineComponent, toRefs, watch, onBeforeMount, toRaw } from "vue";
import { GoogleMap, Marker, InfoWindow } from "vue3-google-map";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ReportReady",
  components: {
    GoogleMap,
    Marker,
    InfoWindow,
  },
  props: {
    trial_num: Number,
  },
  setup: function (props) {
    const store = useStore();
    const mapRef = ref(null);
    let patient_values = [] as any;
    const center = ref({ lat: 39.87355222614361, lng: -100.87624332851627 });
    let marker_positions3 = ref([]) as any;
    let marker_positions = [] as any;
    const widget_results = ref([]) as any;
    const { t } = useI18n();
    onBeforeMount(() => {
      store.dispatch(Actions.GET_PATIENT_VALUES_LONGTEXT, {
        keyp: "widget_result",
      });
    });
    watch(
      () => mapRef.value,
      function (rs) {
        watch(
          () => store.getters.getPatientLongtextValues,
          function (r) {
            let raw = toRaw(r);

            if (raw.valuep) {
              let pv_longtext_raw = JSON.parse(raw.valuep);

              center.value = store.getters.getPatientCTMSMapCenterInitial;

              let pv_raw = toRaw(store.state.ApiModule);

              if (pv_raw.patient_values.matching_result_settings) {
                let matching_result_settings = JSON.parse(
                  pv_raw.patient_values.matching_result_settings
                );
                let potential_trials_list =
                  matching_result_settings.selected_trials
                    .potential_trials_list;
                console.log(potential_trials_list);

                patient_values = pv_raw.patient_values;
                var i;
                for (i = 0; i < pv_longtext_raw.length; i++) {
                  if (
                    pv_longtext_raw[i] &&
                    pv_longtext_raw[i].trialid &&
                    potential_trials_list.indexOf(
                      pv_longtext_raw[i].trialid
                    ) !== -1
                  ) {
                    widget_results.value.push(pv_longtext_raw[i]);

                    if (pv_longtext_raw[i].lat) {
                      marker_positions.push({
                        lat: pv_longtext_raw[i].lat,
                        lng: pv_longtext_raw[i].lng,
                      });
                      marker_positions3.value.push({
                        position: {
                          lat: parseFloat(pv_longtext_raw[i].lat),
                          lng: parseFloat(pv_longtext_raw[i].lng),
                        },
                        infowindow: pv_longtext_raw[i],
                      });
                      //Object.assign(marker_positions3.value, {position: {lat: parseFloat(pv_longtext_raw[i].lat), lng: parseFloat(pv_longtext_raw[i].lng)}});
                      //Object.assign(marker_positions3.value, {infowindow: pv_longtext_raw[i]});
                    }
                  }
                }
              }
            }
          }
        );
      }
    );

    return {
      center,
      mapRef,
      marker_positions,
      marker_positions3,
      t,
    };
  },
});
